// 표 위 카운트 밑줄 세그 (시안 .fseg) — 상태별 건수 필터. 가로 스크롤.
// props: items:[{id, label, count, color}], value (활성 id), onChange(id), right (우측 끝 보조 노드, 선택)
import React from 'react';
import { T, R, FONT, NUM } from '../theme';

var wrap = { display: 'flex', gap: 18, padding: '0 14px', borderBottom: '1px solid ' + T.bd, background: T.card,
  borderRadius: R.card + 'px ' + R.card + 'px 0 0', overflowX: 'auto', WebkitOverflowScrolling: 'touch', alignItems: 'center' };

function CountSeg(props) {
  return (<div style={wrap} className="v2-cseg" role="tablist">
    {(props.items || []).map(function (it) {
      var on = it.id === props.value;
      var st = { padding: '10px 2px 9px', fontSize: FONT.body, fontWeight: on ? 800 : 600, color: on ? T.navy : T.muted,
        background: 'none', border: 'none', borderBottom: '3px solid ' + (on ? T.accent : 'transparent'), whiteSpace: 'nowrap',
        display: 'inline-flex', alignItems: 'center', gap: 5, cursor: 'pointer', fontFamily: 'inherit', flexShrink: 0 };
      var bub = Object.assign({ fontSize: FONT.label, padding: '0 5px', borderRadius: 999, background: on ? T.accent : T.bdSoft, color: on ? T.card : T.dim, fontWeight: 700 }, NUM);
      return (<button key={it.id} type="button" role="tab" aria-selected={on} className={'v2-ctab' + (on ? ' on' : '')} style={st}
        onClick={function () { if (props.onChange) props.onChange(it.id); }}>
        {it.color ? <i style={{ width: 7, height: 7, borderRadius: 2, background: it.color, display: 'inline-block' }} /> : null}
        {it.label}
        {it.count != null ? <b style={bub}>{it.count}</b> : null}
      </button>);
    })}
    {props.right ? <span style={{ marginLeft: 'auto', flexShrink: 0, fontSize: FONT.body }}>{props.right}</span> : null}
  </div>);
}

export default CountSeg;
